module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep2-3fdd3ec1428bc5076c9ce15989316546.png";